import { compactDate, timeOfDay } from './usDate';

const DAY = 86400000;

// Calendar days in the viewer's zone, so 23:50 last night is "yesterday".
const daysAgo =(then, now) => {
  const midnight = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  return Math.round((midnight(new Date(now)) - midnight(then)) / DAY);
};

const clock = (then) => timeOfDay(then);

const dayMonth = (then, now) => compactDate(then, { now });

export const bubbleTime = (iso, now = Date.now()) => {
  if (!iso) return '';

  const then = new Date(iso);
  const days = daysAgo(then, now);

  if (Number.isNaN(days)) return '';
  if (days === 0) return `today ${clock(then)}`;
  if (days === 1) return `yesterday ${clock(then)}`;

  return dayMonth(then, now);
};

export const updateTime = (iso, now = Date.now()) => {
  if (!iso) return '';

  const then = new Date(iso);
  const days = daysAgo(then, now);

  if (Number.isNaN(days)) return '';
  if (days === 0) return `Today, ${clock(then)}`;

  return days === 1 ? 'Yesterday' : dayMonth(then, now);
};

export const readTime = (iso, now = Date.now()) => {
  if (!iso) return '';

  const then = new Date(iso);
  const days = daysAgo(then, now);

  if (Number.isNaN(days)) return '';

  return days === 0 ? clock(then) : dayMonth(then, now);
};

/** A person who has never signed in reads "Never", not a blank. */
export const lastActive =(iso, now = Date.now()) => {
  if (!iso) return 'Never';

  const then = new Date(iso);
  const days = daysAgo(then, now);

  if (Number.isNaN(days)) return '';
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} days ago`;

  return compactDate(then, { now });
};
